<template>
	<section class="body">
		<main class="container">
			<div class="row">
				<div class="col mt-12 text-center">
					<h2 class="mt-12">{{ $t('checkin.creditCard.title') }}</h2>

          <!--
          <h3 class="mb-12">{{ $t('checkin.form.title2') }}</h3>
					<p class="mt-12 text-justify" v-html="$t('checkin.form.subtitle2')"></p>
          -->
					<p class="mt-12 text-justify font-weight-bold" v-html="$t('checkin.form.title2')"></p>

					<p class="mb-12 text-justify" v-html="subheader"></p>

					<form action="checkin-plz.html" class="needs-validation" novalidate>
						<div class="row">
							<div class="col mb-20">
								<div class="box-cc p-3 text-left">
									<label for="cc1">{{ $t('ccNumber') }}:</label>
                  <a class="info" data-toggle="modal" data-target="#ccInfo">i</a>
									<div class="form-row mb-2">
										<div class="col-12">
											<input type="tel" v-on:input="formatCCardNumber" v-model="ccnumber"
											       data-layout="numeric" @focus="show" placeholder="#### #### #### ####"
											       class="form-control" id="cc1">
										</div>
									</div>
									<div v-if="this.ccErrors.cardNumber" class="invalid-feedback">Kartennummer nicht korrekt.</div>

									<div class="form-row mb-2">
										<div class="col-6">
											<label for="ccgb1">{{ $t('ccExpiry') }}:</label>
											<div class="form-row">
												<div class="col-10">
													<input type="tel" v-on:input="formatCCardExpires" v-model="ccExpiry" data-layout="numeric" placeholder="MM/YYYY"
													       @focus="show" class="form-control" id="ccgb1" required>
												</div>
											</div>
											<div v-if="this.ccErrors.cardExpiry" class="invalid-feedback">Datum nicht korrekt.</div>
										</div>
										<div class="col-6">
											<label for="cvc">{{ $t('cardCvc') }}:</label>
											<div class="form-row">
												<div class="col-5">
													<input type="password" v-model="ccCvc" class="form-control" id="cvc" max="999" data-layout="numeric" @focus="show"
													       required>
												</div>
												<div class="col-7 text-right">
													<i class="cc-icon" :class="cardBrandClass"></i>
													<!-- <img src="/assets/images/cc.png" class="cc-img"/> -->
												</div>
											</div>
											<div v-if="this.ccErrors.cardCvc" class="invalid-feedback">CVC nicht korrekt.</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row pt-3">
							<div class="col-md-3 text-left">
								<a @click.prevent="lastStep" class="btn btn-secondary btn-prev">Zurück</a>
							</div>
							<div class="col-md-6 pt-3 dots">
								<p><span class="dot"></span> <span class="dot active"></span> <span class="dot"></span>
								</p>
							</div>
							<div class="col-md-3 text-right">
								<button @click.prevent="nextStep" class="btn btn-primary btn-next" type="submit">
									Weiter
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>

      <div id="ccInfo" class="modal fade" role="dialog" aria-labelledby="ccInfo">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Info</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <span v-html="$t( 'checkin.creditCard.directbookingonly' )"></span>
            </div>
          </div>
        </div>
      </div>

		</main>
	</section>
</template>

<script>
	import axios from 'axios'
	import SimpleCrypto from "simple-crypto-js";

	export default {
		props: [],
		data: function () {
			return {
        subheader: this.$t('checkin.creditCard.subtitle'),
				ccnumber: "",
				ccExpiry: "",
				ccBrand: "",
				ccCvc: "",
				ccErrors: {},
				$cardFormat: this.$parent.$cardFormat,
				cards: [
					/*
					{
						type: 'maestro',
						patterns: [
							5018, 502, 503, 506, 56, 58, 639, 6220, 67
						],
						format: /(\d{1,4})/g,
						length: [12, 13, 14, 15, 16, 17, 18, 19],
						cvcLength: [3],
						luhn: true
					},
					{
						type: 'forbrugsforeningen',
						patterns: [600],
						format: /(\d{1,4})/g,
						length: [16],
						cvcLength: [3],
						luhn: true
					},
					{
						type: 'dankort',
						patterns: [5019],
						format: /(\d{1,4})/g,
						length: [16],
						cvcLength: [3],
						luhn: true
					},
					*/
					{
						type: 'visa',
						patterns: [4],
						format: /(\d{1,4})/g,
						length: [13, 16],
						cvcLength: [3],
						luhn: true
					},
					{
						type: 'mastercard',
						patterns: [
							51, 52, 53, 54, 55,
							22, 23, 24, 25, 26, 27
						],
						format: /(\d{1,4})/g,
						length: [16],
						cvcLength: [3],
						luhn: true
					}
					/*
					{
						type: 'amex',
						patterns: [34, 37],
						format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
						length: [15],
						cvcLength: [3, 4],
						luhn: true
					},
					{
						type: 'dinersclub',
						patterns: [30, 36, 38, 39],
						format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
						length: [14],
						cvcLength: [3],
						luhn: true
					},
					{
						type: 'discover',
						patterns: [60, 64, 65, 622],
						format: /(\d{1,4})/g,
						length: [16],
						cvcLength: [3],
						luhn: true
					},
					{
						type: 'unionpay',
						patterns: [62, 88],
						format: /(\d{1,4})/g,
						length: [16, 17, 18, 19],
						cvcLength: [3],
						luhn: false
					},
					{
						type: 'jcb',
						patterns: [35],
						format: /(\d{1,4})/g,
						length: [16],
						cvcLength: [3],
						luhn: true
					}
					*/
				]
			}
		},
		computed: {
			cardBrandClass() {
				if (this.$cardFormat.validateCardNumber(this.ccnumber)) {
					return this.getBrandClass(this.ccBrand.type);
				} else {
					return "";
				}

			}
		},
    created: function() {
      this.subheader = this.subheader.replace("###price###",this.$parent.guest.roomCategory.price);
    },
		methods: {
			lastStep() {
        this.$parent.hide();
				this.$parent.direction = false;
				this.$parent.component = 'CheckinSelectRoom';
			},
			nextStep() {
				this.$parent.direction = true;
				let self = this;
				if(this.validate()) {
					var ccData = {};
          ccData.ccBrand = this.ccBrand.type;
					ccData.ccNumber = this.ccnumber;
					ccData.ccExpiry = this.ccExpiry;
					ccData.cardCvc = this.ccCvc;

          // console.log(['CCDATA',ccData]);

          //TODO:Random Generator für den Key
					var _secretKey = "sQ96LgjttsJbLTPNJNDWJTag4QjyzmYzoYvRH2mA";
					var simpleCrypto = new SimpleCrypto(_secretKey);
					this.$parent.guest.ccCard = simpleCrypto.encrypt(ccData);
					// console.log(this.$parent.guest.ccCard);
					var decryptCode = simpleCrypto.decrypt(this.$parent.guest.ccCard);
          this.$parent.guest.ccCardData = _secretKey;
					// console.log(['GuestData', decryptCode]);


					this.ccnumber =  '';
					this.ccExpiry = '';
					this.ccCvc = '';

          // console.log(this.$parent.guest);
          this.$parent.hide();
					this.$parent.component = 'CheckinForm'
				}

			},

			/** Credit Card Functions **/

			// Validate Credit Card informations
			validate: function () {
				let noerror = true;

				// init
				this.ccErrors = {};

				// validate card number
				if (!this.$cardFormat.validateCardNumber(this.ccnumber)) {
					this.ccErrors.cardNumber = true;
					noerror = false;
				} else {
					this.ccErrors.cardNumber = false;
				}

				// validate card expiry
				if (!this.$cardFormat.validateCardExpiry(this.ccExpiry)) {
					this.ccErrors.cardExpiry = true;
					noerror = false;
				} else {
					this.ccErrors.cardExpiry = false;
				}

				// validate card CVC
				if (!this.$cardFormat.validateCardCVC(this.ccCvc)) {
					this.ccErrors.cardCvc = true;
					noerror = false;
				} else {
					this.ccErrors.cardCvc = false;
				}

				return noerror;

			},

			// Get Credit Card Name from Number
			cardFromNumber(num) {
				num = (num + '').replace(/\D/g, '');
				for (var i in this.cards) {
					for (var j in this.cards[i].patterns) {
						var p = this.cards[i].patterns[j] + '';
						if (num.substr(0, p.length) === p) {
							return this.cards[i];
						}
					}
				}
			},

			// Helper functions for Credit Card
			formatCCardNumber() {
				if (this.ccnumber.length > 0) {
					let reqExValue = '.{1,4}$|.{1,4}';
					this.ccnumber = this.ccnumber.split(" ").join("");
					this.ccnumber = this.ccnumber.match(new RegExp(reqExValue, 'g')).join(" ");

					this.ccBrand = this.cardFromNumber(this.ccnumber);
				}
			},

			formatCCardExpires() {
				if (this.ccExpiry.length > 0) {
					let reqExValue = '^.{1,2}|.{1,4}$';
					this.ccExpiry = this.ccExpiry.split("/").join("");
					this.ccExpiry = this.ccExpiry.match(new RegExp(reqExValue, 'g')).join("/");
				}
			},

			getBrandClass: function (brand) {
				let icon = '';
				brand = brand || 'unknown';
				let cardBrandToClass = {
					'visa': 'fab fa-cc-visa',
					'mastercard': 'fab fa-cc-mastercard',
					'amex': 'fab fa-cc-amex',
					'discover': 'fab fa-cc-discover',
					'diners': 'fab fa-cc-diners-club',
					'jcb': 'fab fa-cc-jcb',
					'unknown': 'fa fa-credit-card',
				};
				if (cardBrandToClass[brand]) {
					icon = cardBrandToClass[brand];
				}
				return icon;
			},

			/** Keyboard Events **/
			accept(text) {
				this.$parent.accept(text);
			},
			show(e) {
				this.$parent.show(e);
			},

			hide() {
				this.$parent.hide();
			},

			next() {
				this.$parent.next();
			},

		},

		components: {
			SimpleCrypto
		}
	}
</script>

<style scoped lang="scss">
	.correct-cc-number {
		border: 1px solid #00FF00;
	}

	i.cc-icon {
		font-size: 72px;
	}

	.invalid-feedback {
		display: block;
	}

  h5.modal-title {
    background: none;
    color: black;
    -webkit-text-fill-color: black;
  }

  .modal-body {
    color: black;
  }


  .info {
    right: 1rem;
    bottom: 1rem;
    background-image: linear-gradient(135deg,#989fa4,#c8d3d9,#989fa4);
    width: 2.5rem;
    height: 2.5rem;
    color: #000 !important;
    font-weight: bold;
    border-radius: 100%;
    padding-top: .5rem;
    font-size: 1.25rem;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    float: right;
    padding-left: 1.1rem;
    &:hover,
    &:focus,
    &:active {
      color: #000;
    }
  }
</style>
